import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { DateLozenge } from './DateLozenge';
import React from 'react';
import format from 'date-fns/format';
var isClickable = function isClickable(props) {
  return !!props.onClick;
};
export var Date = /*#__PURE__*/function (_React$Component) {
  _inherits(Date, _React$Component);
  var _super = _createSuper(Date);
  function Date() {
    var _this;
    _classCallCheck(this, Date);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      if (isClickable(_this.props)) {
        _this.props.onClick(_this.props.value, event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      if (_this.props.children) {
        if (typeof _this.props.children === 'function') {
          return _this.props.children(_this.props);
        }
        return _this.props.children;
      }
      return format(_this.props.value, _this.props.format || '');
    });
    return _this;
  }
  _createClass(Date, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(DateLozenge, {
        className: this.props.className,
        onClick: isClickable(this.props) ? this.handleOnClick : undefined,
        color: this.props.color
      }, this.renderContent());
    }
  }]);
  return Date;
}(React.Component);
_defineProperty(Date, "displayName", 'Date');
_defineProperty(Date, "defaultProps", {
  format: 'dd/MM/yyyy',
  color: 'grey'
});